import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { withPromisedComponent } from "@components/dialog/withPromisedComponent";
import { DocumentTypeCode } from "@odata/GeneratedEnums";
import { checkEmployeeTypeAndSetVariant, isEmployeeBPType } from "@pages/documents/otherLiability/OtherLiability.utils";

import { withDomManipulator } from "../../../contexts/domManipulator/withDomManipulator";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { IProps } from "../../../views/formView/Form";
import { withMinorAssetPairing } from "../../asset/minorAsset/withMinorAssetPairing";
import { withAccruals } from "../extensions/accruals/withAccruals";
import { withTimeResolution } from "../extensions/timeResolution/withTimeResolution";
import ReceivedDocumentBaseFormView from "../ReceivedDocumentBaseFormView";


class OtherLiabilityFormView extends ReceivedDocumentBaseFormView {
    documentTypeCode = DocumentTypeCode.OtherLiability;
    documentTypePropName = "LiabilityType";

    preloadCheck = () => checkEmployeeTypeAndSetVariant(this.props.storage);

    getFormProps = (): Partial<IProps> => {
        const { storage, formProps = {} } = this.props;
        const isEmployee = isEmployeeBPType(storage.data.entity.BusinessPartner);
        return {
            shouldHideVariant: isEmployee ? true : formProps.shouldHideVariant,
            ...formProps
        };
    };
}

export default withPromisedComponent(withConfirmationDialog(withMinorAssetPairing(withTimeResolution(withAccruals({ isExpense: true })(withPermissionContext(withDomManipulator(OtherLiabilityFormView)))))));
